import React from "react";

const LOGO = "https://customer-assets.emergentagent.com/job_2e8a6a93-30a9-4e91-a7a5-a9394acf49bd/artifacts/xwzvhvs5_Header%20Logo%20Ethia.png";

const MaroonFooter = () => (
  <footer className="py-12 md:py-16" style={{ background: "#5C0F1C" }} data-testid="maroon-footer">
    <div className="max-w-[1100px] mx-auto px-6 md:px-[52px]">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 mb-10">
        <div className="sm:col-span-2 md:col-span-1 space-y-4">
          <img src={LOGO} alt="ETHIA" className="h-16" />
          <p className="text-sm leading-relaxed max-w-xs" style={{ color: "#F5EDD6CC", fontFamily: "Manrope, sans-serif" }}>
            India's first cultivated pet food born from one question. Built on one mission — to nourish pets without harming animals.
          </p>
          <p className="text-sm italic" style={{ color: "#F5EDD6", fontFamily: "Manrope, sans-serif" }}>Made with Love in India &#10084;&#65039;</p>
        </div>
        <div>
          <h3 className="font-bold text-lg mb-4" style={{ color: "#F5C800", fontFamily: "Fraunces, serif" }}>Quick Links</h3>
          <ul className="space-y-2.5">
            {[["About Us","/about"],["Science","/science"],["Products","/products"],["Early Access","/early-access"],["Contact","/contact"],["Refund Policy","/refund-policy"]].map(([label,href])=>(
              <li key={label}><a href={href} className="text-sm hover:underline transition-colors" style={{ color: "#F5EDD6CC", fontFamily: "Manrope, sans-serif" }}>{label}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-bold text-lg mb-4" style={{ color: "#F5C800", fontFamily: "Fraunces, serif" }}>Contact Us</h3>
          <ul className="space-y-2.5" style={{ color: "#F5EDD6CC", fontFamily: "Manrope, sans-serif" }}>
            <li className="text-sm">+91 93279 27782</li>
            <li className="text-sm">admin@ethia.in</li>
            <li className="text-sm">ethia.in</li>
          </ul>
        </div>
      </div>
      <div className="pt-6" style={{ borderTop: "1px solid #621B21" }}>
        <p className="text-center text-xs" style={{ color: "#F5EDD680", fontFamily: "Manrope, sans-serif" }}>&copy; 2025 ETHIA. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default MaroonFooter;
